export const SetOrdered = `list-decimal font-secondary pl-[40px]`

export const SetUnordered = `list-disc font-secondary pl-[40px]`

export const WithIconContainer = `pt-4 pb-4 font-secondary`
export const WithIconFlex = `flex items-start`
export const WithIconPadding = `pl-2 pb-2`
